import React, { useState, useEffect } from "react";
import { C, FontLink } from "./constants";

// ── SVG ICONS ─────────────────────────────────────────────────
const IconApple = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const IconArrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

const IconCheck = ({ color = C.green }) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const IconShield = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.green} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const IconMoon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.purple} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

const IconTrend = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.amber} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
    <polyline points="17 6 23 6 23 12"/>
  </svg>
);

const IconTarget = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.green} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

const IconWifi = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.blue} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <line x1="1" y1="1" x2="23" y2="23"/>
    <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/>
    <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/>
    <path d="M10.71 5.05A16 16 0 0 1 22.56 9"/>
    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/>
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
    <line x1="12" y1="20" x2="12.01" y2="20"/>
  </svg>
);

const IconRepeat = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.purple} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9"/>
    <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
    <polyline points="7 23 3 19 7 15"/>
    <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
  </svg>
);

const IconZakat = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.gold} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);

const IconChevron = ({ open }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s" }}>
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

const IconBook = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={C.amber} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);

const IconPercent = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={C.gold} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="5" x2="5" y2="19"/>
    <circle cx="6.5" cy="6.5" r="2.5"/>
    <circle cx="17.5" cy="17.5" r="2.5"/>
  </svg>
);

const IconScale = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={C.purple} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="3" x2="12" y2="21"/>
    <path d="M3 6l4 4 4-4"/>
    <path d="M21 6l-4 4-4-4"/>
    <line x1="5" y1="20" x2="19" y2="20"/>
  </svg>
);

const IconHalal = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={C.green} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
    <line x1="9" y1="9" x2="9.01" y2="9"/>
    <line x1="15" y1="9" x2="15.01" y2="9"/>
  </svg>
);

// ── MOCK APP SCREEN — visual proof of the product ─────────────
function MockAppScreen() {
  const bar = (label, pct, color, amount) => (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
        <span style={{ fontSize: 11, color: C.text2, fontWeight: 600 }}>{label}</span>
        <span style={{ fontSize: 11, color: C.text3 }}>{amount}</span>
      </div>
      <div style={{ height: 4, background: "rgba(255,255,255,0.06)", borderRadius: 99, overflow: "hidden" }}>
        <div style={{ height: "100%", width: pct + "%", background: color, borderRadius: 99 }} />
      </div>
    </div>
  );

  return (
    <div style={{
      background: C.surface,
      border: `1px solid ${C.border}`,
      borderRadius: 20,
      overflow: "hidden",
      width: "100%",
      maxWidth: 320,
      margin: "0 auto",
      boxShadow: "0 32px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {/* Fake status bar */}
      <div style={{ background: C.surface2, padding: "10px 16px 8px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: C.text }}>
          <span style={{ color: C.text, fontWeight: 800 }}>barakah</span>
          <span style={{ color: C.green, fontWeight: 400 }}>budget</span>
        </span>
        <div style={{ width: 28, height: 28, borderRadius: "50%", background: "rgba(61,214,140,0.12)", border: "1.5px solid rgba(61,214,140,0.25)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: 10, fontWeight: 800, color: C.green }}>M</span>
        </div>
      </div>

      <div style={{ padding: "16px 16px 20px" }}>
        {/* Spending hero */}
        <div style={{
          background: "radial-gradient(ellipse at top left, rgba(61,214,140,0.08) 0%, rgba(22,22,30,0) 65%)",
          border: `1px solid ${C.border}`,
          borderRadius: 14,
          padding: "16px",
          marginBottom: 12,
        }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: C.text3, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 6 }}>May 2026</div>
          <div style={{ fontSize: 32, fontWeight: 800, color: C.text, letterSpacing: "-0.04em", lineHeight: 1, marginBottom: 2 }}>CA$847<span style={{ fontSize: 16, fontWeight: 600, color: C.text2 }}>.20</span></div>
          <div style={{ fontSize: 11, color: C.text3, marginBottom: 12 }}>spent this month</div>
          {/* Mini line chart mock */}
          <svg viewBox="0 0 280 40" style={{ width: "100%", height: 40 }}>
            <defs>
              <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#a78bfa" stopOpacity="0.3"/>
                <stop offset="100%" stopColor="#a78bfa" stopOpacity="0"/>
              </linearGradient>
            </defs>
            <path d="M0 38 L30 34 L60 30 L90 28 L120 24 L150 22 L180 18 L210 20 L240 14 L280 10" fill="none" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M0 38 L30 34 L60 30 L90 28 L120 24 L150 22 L180 18 L210 20 L240 14 L280 10 L280 40 L0 40 Z" fill="url(#chartGrad)"/>
            <circle cx="280" cy="10" r="3.5" fill="#a78bfa"/>
          </svg>
        </div>

        {/* Category breakdown */}
        <div style={{ background: C.surface2, border: `1px solid ${C.border}`, borderRadius: 14, padding: "14px 14px 10px", marginBottom: 12 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: C.text3, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 12 }}>Top Categories</div>
          {bar("Groceries", 72, "#22c55e", "CA$310")}
          {bar("Transport", 45, "#3b82f6", "CA$193")}
          {bar("Dining Out", 30, "#f43f5e", "CA$128")}
          {bar("Sadaqah", 18, "#4ade80", "CA$75")}
        </div>

        {/* Zakat pill */}
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ flex: 1, background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.2)", borderRadius: 10, padding: "10px 12px" }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: "#d4af37", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 3 }}>Zakat</div>
            <div style={{ fontSize: 13, fontWeight: 800, color: C.text }}>CA$412</div>
            <div style={{ fontSize: 9, color: C.text3 }}>due this year</div>
          </div>
          <div style={{ flex: 1, background: "rgba(61,214,140,0.06)", border: "1px solid rgba(61,214,140,0.15)", borderRadius: 10, padding: "10px 12px" }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: C.green, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 3 }}>Savings Goal</div>
            <div style={{ fontSize: 13, fontWeight: 800, color: C.text }}>68%</div>
            <div style={{ fontSize: 9, color: C.text3 }}>Emergency Fund</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── TRUST STAT ITEM ───────────────────────────────────────────
function TrustStat({ value, label, color = C.green }) {
  return (
    <div style={{ textAlign: "center", padding: "0 8px" }}>
      <div style={{ fontSize: "clamp(26px, 5vw, 36px)", fontWeight: 900, color, letterSpacing: "-0.03em", lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: 12, color: C.text2, marginTop: 4, lineHeight: 1.4 }}>{label}</div>
    </div>
  );
}

// ── FEATURE CARD ──────────────────────────────────────────────
function FeatureCard({ icon, iconBg, title, desc }) {
  return (
    <div style={{
      background: C.surface,
      border: `1px solid ${C.border}`,
      borderRadius: 16,
      padding: "24px 22px",
      display: "flex",
      flexDirection: "column",
      gap: 0,
      transition: "border-color 0.2s",
    }}>
      <div style={{
        width: 52,
        height: 52,
        borderRadius: 14,
        background: iconBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 16,
        flexShrink: 0,
      }}>
        {icon}
      </div>
      <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 8, lineHeight: 1.3 }}>{title}</div>
      <p style={{ fontSize: 13, color: C.text2, lineHeight: 1.7, margin: 0 }}>{desc}</p>
    </div>
  );
}

// ── EDUCATION CARD ────────────────────────────────────────────
function EduCard({ icon, iconBg, term, definition }) {
  return (
    <div style={{
      background: C.surface,
      border: `1px solid ${C.border}`,
      borderRadius: 16,
      padding: "24px 22px",
      display: "flex",
      flexDirection: "column",
      gap: 0,
    }}>
      <div style={{
        width: 48,
        height: 48,
        borderRadius: 13,
        background: iconBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 14,
        flexShrink: 0,
      }}>
        {icon}
      </div>
      <div style={{ fontSize: 11, fontWeight: 700, color: C.text3, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 6 }}>What is</div>
      <div style={{ fontSize: 18, fontWeight: 900, color: C.text, marginBottom: 10, letterSpacing: "-0.02em" }}>{term}?</div>
      <p style={{ fontSize: 13, color: C.text2, lineHeight: 1.75, margin: 0 }}>{definition}</p>
    </div>
  );
}

// ── PRICING TIER ──────────────────────────────────────────────
function PricingCard({ tier, price, period, subNote, features, highlight, cta, href }) {
  return (
    <div style={{
      background: highlight ? "linear-gradient(145deg, rgba(167,139,250,0.08) 0%, rgba(22,22,30,1) 60%)" : C.surface,
      border: highlight ? `1px solid rgba(167,139,250,0.3)` : `1px solid ${C.border}`,
      borderRadius: 20,
      padding: "28px 24px",
      flex: 1,
      minWidth: 0,
      position: "relative",
    }}>
      {highlight && (
        <div style={{
          position: "absolute",
          top: -11,
          left: "50%",
          transform: "translateX(-50%)",
          background: C.purple,
          color: "#0e0e13",
          fontSize: 10,
          fontWeight: 800,
          padding: "3px 12px",
          borderRadius: 20,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}>Most Popular</div>
      )}
      <div style={{ fontSize: 12, fontWeight: 700, color: highlight ? C.purple : C.text3, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 12 }}>{tier}</div>
      <div style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap", gap: 4, marginBottom: 4 }}>
        <span style={{ fontSize: 32, fontWeight: 900, color: C.text, letterSpacing: "-0.03em", whiteSpace: "nowrap" }}>{price}</span>
        {period && <span style={{ fontSize: 13, color: C.text3, whiteSpace: "nowrap" }}>{period}</span>}
      </div>
      <div style={{ fontSize: 12, color: C.text3, marginBottom: 24, minHeight: 18 }}>{subNote}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
        {features.map((f, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
            <div style={{ marginTop: 1, flexShrink: 0 }}><IconCheck color={highlight ? C.purple : C.green} /></div>
            <span style={{ fontSize: 13, color: C.text2, lineHeight: 1.5 }}>{f}</span>
          </div>
        ))}
      </div>
      <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel={href.startsWith("http") ? "noopener noreferrer" : undefined} style={{
        display: "block",
        textAlign: "center",
        padding: "13px 20px",
        borderRadius: 12,
        fontSize: 14,
        fontWeight: 700,
        textDecoration: "none",
        background: highlight ? C.purple : "rgba(255,255,255,0.06)",
        color: highlight ? "#fff" : C.text2,
        border: highlight ? "none" : `1px solid ${C.border}`,
        boxShadow: highlight ? "0 4px 20px rgba(167,139,250,0.25)" : "none",
        transition: "opacity 0.15s",
      }}>{cta}</a>
    </div>
  );
}

// ── FAQ ACCORDION ITEM ────────────────────────────────────────
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{
      borderBottom: `1px solid ${C.border}`,
      overflow: "hidden",
    }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: "100%",
          background: "none",
          border: "none",
          padding: "18px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <span style={{ fontSize: 15, fontWeight: 600, color: C.text, lineHeight: 1.4 }}>{q}</span>
        <span style={{ color: C.text3, flexShrink: 0 }}><IconChevron open={open} /></span>
      </button>
      <div style={{
        maxHeight: open ? 400 : 0,
        overflow: "hidden",
        transition: "max-height 0.3s ease",
      }}>
        <p style={{ fontSize: 14, color: C.text2, lineHeight: 1.75, margin: "0 0 20px", paddingRight: 32 }}>{a}</p>
      </div>
    </div>
  );
}

// ── STICKY DOWNLOAD BANNER ────────────────────────────────────
function StickyBanner({ visible }) {
  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 200,
      padding: "12px 20px",
      background: "rgba(14,14,19,0.96)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      borderTop: `1px solid ${C.border}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      flexWrap: "wrap",
      transform: visible ? "translateY(0)" : "translateY(100%)",
      transition: "transform 0.35s ease",
      pointerEvents: visible ? "auto" : "none",
    }}>
      <span style={{ fontSize: 13, color: C.text2 }}>Free to download · No account required</span>
      <a
        href="https://apps.apple.com/app/id6772805412"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 7,
          background: "linear-gradient(135deg, #3dd68c, #22c55e)",
          color: "#0e0e13",
          fontWeight: 800,
          fontSize: 13,
          padding: "10px 20px",
          borderRadius: 10,
          textDecoration: "none",
          boxShadow: "0 4px 16px rgba(61,214,140,0.3)",
          whiteSpace: "nowrap",
        }}
      >
        <IconApple />
        Download on App Store
      </a>
    </div>
  );
}

// ── MAIN COMPONENT ────────────────────────────────────────────
export function LandingPage() {
  const [scrolled, setScrolled] = useState(false);
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
      setPastHero(window.scrollY > 480);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  const sectionEyebrow = (text, color = C.green) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 14 }}>
      <div style={{ width: 20, height: 1.5, background: color, borderRadius: 2 }} />
      <span style={{ fontSize: 11, fontWeight: 700, color, letterSpacing: "0.1em", textTransform: "uppercase" }}>{text}</span>
      <div style={{ width: 20, height: 1.5, background: color, borderRadius: 2 }} />
    </div>
  );

  const sectionHeading = (text, sub = null) => (
    <div style={{ textAlign: "center", marginBottom: sub ? 12 : 48 }}>
      <h2 style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 900, color: C.text, letterSpacing: "-0.025em", lineHeight: 1.2, margin: 0 }}>{text}</h2>
      {sub && <p style={{ fontSize: 15, color: C.text2, lineHeight: 1.7, marginTop: 12, marginBottom: 40, maxWidth: 520, marginLeft: "auto", marginRight: "auto" }}>{sub}</p>}
    </div>
  );

  // ── JSON-LD Structured Data ──────────────────────────────────
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Barakah Budget",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "iOS, Web",
    "description": "Barakah Budget is a halal personal finance app for Muslims. Track expenses, calculate Zakat automatically with live nisab, flag riba income, and set Islamic savings goals — all offline, no account required.",
    "url": "https://barakahbudget.com",
    "downloadUrl": "https://apps.apple.com/app/id6772805412",
    "offers": [
      {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CAD",
        "name": "Free"
      },
      {
        "@type": "Offer",
        "price": "4.99",
        "priceCurrency": "CAD",
        "name": "Pro",
        "billingDuration": "P1M"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "15"
    },
    "author": {
      "@type": "Person",
      "name": "Mufeed Muneer"
    },
    "keywords": "halal budgeting app, Islamic finance app, zakat calculator app, Muslim budget tracker, halal personal finance, riba-free budgeting",
    "inLanguage": "en",
    "datePublished": "2026-01-01",
    "softwareVersion": "1.0"
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Is Barakah Budget free?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. The core app is free forever — unlimited transactions, Zakat calculator, calendar view, budget presets, goals (up to 3), debt tracker (up to 2), recurring bills, and offline access. Pro (CA$4.99/month or CA$39.99/year) unlocks unlimited goals and debts, spending analysis, manual budget control, CSV export, and priority support."
        }
      },
      {
        "@type": "Question",
        "name": "Is Barakah Budget available on iPhone?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Barakah Budget is available on the App Store for iPhone. You can download it at https://apps.apple.com/app/id6772805412. A web app is also available at barakahbudget.com/app and works on any device with a browser."
        }
      },
      {
        "@type": "Question",
        "name": "How does the Zakat calculator work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You enter your savings, gold holdings, silver, and receivables. Barakah Budget fetches live gold and silver prices to calculate the current nisab threshold (approximately CA$1,491 using the silver standard). If your qualifying wealth exceeds the nisab and has been held for one lunar year, the app calculates your 2.5% Zakat obligation automatically."
        }
      },
      {
        "@type": "Question",
        "name": "Is my financial data safe?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Completely. Barakah Budget stores all your data on your device only — there is no server, no account, no cloud sync. Your transactions are never sent over the internet. Even the developers cannot see your data. You can export it anytime as a JSON or CSV backup."
        }
      },
      {
        "@type": "Question",
        "name": "What makes Barakah Budget halal?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Barakah Budget is built around Islamic finance principles from the ground up — not adapted from a generic app. It flags riba (interest) income so you can purify it through Sadaqah, uses halal-aware spending categories (Sadaqah, halal vs haram debt), separates halal and riba-bearing debts, includes a built-in Zakat calculator, and offers Islamic savings goal presets like Hajj Fund, Mahr, and Sadaqah Jariya."
        }
      },
      {
        "@type": "Question",
        "name": "Does Barakah Budget work without internet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, completely. The app works 100% offline. All your data is stored on your device. You can log transactions, view your budget, check goals, and use the Zakat calculator with no internet connection. The only feature requiring internet is fetching live gold/silver prices for the Zakat nisab calculation, and even that falls back gracefully to the last fetched value."
        }
      }
    ]
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: C.bg,
      color: C.text,
      fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
      WebkitFontSmoothing: "antialiased",
      overflowX: "hidden",
    }}>
      <FontLink />

      {/* ── JSON-LD Structured Data ─────────────────────────── */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />

      {/* ── GLOBAL KEYFRAMES injected once ─────────────────────── */}
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes glowPulse {
          0%, 100% { opacity: 0.5; }
          50%       { opacity: 1; }
        }
        .land-nav-cta:hover { opacity: 0.85; }
        .land-cta-primary:hover { opacity: 0.9; transform: translateY(-1px); }
        .land-cta-secondary:hover { background: rgba(255,255,255,0.07) !important; }
        .land-footer-link:hover { color: ${C.purple} !important; }
        .faq-btn:hover { background: rgba(255,255,255,0.02); }
      `}</style>

      {/* ── STICKY DOWNLOAD BANNER ──────────────────────────────── */}
      <StickyBanner visible={pastHero} />

      {/* ══════════════════════════════════════════════════════════
          NAV
      ══════════════════════════════════════════════════════════ */}
      <nav style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: scrolled ? "rgba(14,14,19,0.92)" : "rgba(14,14,19,0.6)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        borderBottom: scrolled ? `1px solid ${C.border}` : "1px solid transparent",
        transition: "background 0.3s, border-color 0.3s",
      }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "0 20px", height: 60, display: "flex", alignItems: "center" }}>
          {/* Logo */}
          <a href="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 32,
              height: 32,
              borderRadius: 9,
              background: "rgba(61,214,140,0.12)",
              border: "1px solid rgba(61,214,140,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 16,
            }}>🌙</div>
            <span style={{ fontSize: 15, fontWeight: 800, color: C.text }}>
              barakah<span style={{ color: C.green, fontWeight: 400 }}>budget</span>
            </span>
          </a>

          {/* Nav links */}
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
            <a href="#features" style={{ fontSize: 13, color: C.text2, textDecoration: "none", padding: "7px 12px", borderRadius: 8 }}>Features</a>
            <a href="#pricing" style={{ fontSize: 13, color: C.text2, textDecoration: "none", padding: "7px 12px", borderRadius: 8 }}>Pricing</a>
            <a href="https://apps.apple.com/app/id6772805412" target="_blank" rel="noopener noreferrer" className="land-nav-cta" style={{
              fontSize: 13,
              fontWeight: 700,
              color: C.green,
              textDecoration: "none",
              padding: "8px 16px",
              borderRadius: 20,
              border: "1px solid rgba(61,214,140,0.3)",
              background: "rgba(61,214,140,0.06)",
              marginLeft: 8,
              transition: "opacity 0.15s",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}><IconApple /> App Store</a>
          </div>
        </div>
      </nav>

      {/* ══════════════════════════════════════════════════════════
          HERO
      ══════════════════════════════════════════════════════════ */}
      <section style={{ padding: "72px 20px 80px", position: "relative", overflow: "hidden" }}>
        {/* Ambient background glow */}
        <div aria-hidden="true" style={{
          position: "absolute",
          top: "5%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "min(700px, 140vw)",
          height: 500,
          background: "radial-gradient(ellipse at center, rgba(167,139,250,0.09) 0%, rgba(61,214,140,0.04) 40%, transparent 70%)",
          pointerEvents: "none",
          animation: "glowPulse 6s ease-in-out infinite",
        }} />

        <div style={{ maxWidth: 1000, margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
          {/* Eyebrow badge */}
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "rgba(61,214,140,0.08)",
            border: "1px solid rgba(61,214,140,0.2)",
            borderRadius: 20,
            padding: "5px 14px 5px 10px",
            marginBottom: 28,
            animation: "fadeIn 0.6s ease both",
          }}>
            <span style={{ fontSize: 13 }}>🌙</span>
            <span style={{ fontSize: 11, fontWeight: 700, color: C.green, letterSpacing: "0.08em", textTransform: "uppercase" }}>Halal Personal Finance App</span>
          </div>

          {/* Hero headline */}
          <h1 style={{
            fontSize: "clamp(34px, 7vw, 62px)",
            fontWeight: 900,
            color: C.text,
            lineHeight: 1.1,
            letterSpacing: "-0.03em",
            textAlign: "center",
            maxWidth: 720,
            margin: "0 auto 20px",
            animation: "fadeUp 0.5s 0.1s ease both",
          }}>
            Most budgeting apps don't care if your money is halal.{" "}
            <span style={{
              background: `linear-gradient(135deg, ${C.green} 0%, ${C.purple} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}>
              This one does.
            </span>
          </h1>

          {/* Hero sub */}
          <p style={{
            fontSize: "clamp(15px, 2.5vw, 18px)",
            color: C.text2,
            lineHeight: 1.7,
            textAlign: "center",
            maxWidth: 540,
            margin: "0 auto 16px",
            animation: "fadeUp 0.5s 0.2s ease both",
          }}>
            Know your nisab. Track your riba. Save for Hajj. Barakah Budget is the Islamic finance app built for Muslims — with a Zakat calculator, halal-first categories, and your data never leaving your device.
          </p>

          {/* Social proof */}
          <p style={{
            fontSize: 13,
            color: C.text3,
            textAlign: "center",
            marginBottom: 36,
            animation: "fadeIn 0.5s 0.25s ease both",
          }}>
            🌍 Join Muslims in <strong style={{ color: C.text2 }}>15+ countries</strong> tracking their finances the halal way
          </p>

          {/* CTA row */}
          <div style={{
            display: "flex",
            gap: 12,
            flexWrap: "wrap",
            justifyContent: "center",
            marginBottom: 16,
            animation: "fadeUp 0.5s 0.3s ease both",
          }}>
            <a href="https://apps.apple.com/app/id6772805412" target="_blank" rel="noopener noreferrer" className="land-cta-primary" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "linear-gradient(135deg, #3dd68c, #22c55e)",
              color: "#0e0e13",
              fontWeight: 800,
              fontSize: 15,
              padding: "14px 26px",
              borderRadius: 14,
              textDecoration: "none",
              boxShadow: "0 4px 24px rgba(61,214,140,0.3)",
              transition: "opacity 0.15s, transform 0.15s",
            }}>
              <IconApple />
              Download on App Store
            </a>
            <a href="/app" className="land-cta-secondary" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "rgba(255,255,255,0.05)",
              color: C.text,
              fontWeight: 600,
              fontSize: 15,
              padding: "14px 26px",
              borderRadius: 14,
              textDecoration: "none",
              border: `1px solid ${C.border2}`,
              transition: "background 0.15s",
            }}>
              Open Web App <IconArrow />
            </a>
          </div>

          {/* Trust chips */}
          <p style={{ fontSize: 12, color: C.text3, textAlign: "center", animation: "fadeIn 0.5s 0.4s ease both" }}>
            Free to download &nbsp;·&nbsp; No account required &nbsp;·&nbsp; Your data stays on your device
          </p>

          {/* App screenshot mockup */}
          <div style={{
            marginTop: 60,
            width: "100%",
            maxWidth: 360,
            animation: "fadeUp 0.7s 0.35s ease both",
          }}>
            <MockAppScreen />
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          TRUST STATS BAR
      ══════════════════════════════════════════════════════════ */}
      <div style={{ borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}` }}>
        <div style={{
          maxWidth: 800,
          margin: "0 auto",
          padding: "32px 20px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "24px 40px",
        }}>
          <TrustStat value="100%" label="data stays on your device" color={C.green} />
          <div style={{ width: 1, background: C.border, alignSelf: "stretch", minHeight: 40 }} />
          <TrustStat value="0" label="servers storing your data" color={C.text} />
          <div style={{ width: 1, background: C.border, alignSelf: "stretch", minHeight: 40 }} />
          <TrustStat value="15+" label="countries using it daily" color={C.purple} />
          <div style={{ width: 1, background: C.border, alignSelf: "stretch", minHeight: 40 }} />
          <TrustStat value="Free" label="to start — no card needed" color={C.amber} />
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════
          FEATURES
      ══════════════════════════════════════════════════════════ */}
      <section id="features" style={{ padding: "80px 20px 80px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          {sectionEyebrow("Built for Muslims", C.green)}
          {sectionHeading(
            "Your finances are an amanah. Treat them that way.",
            "From daily halal budgeting to automatic Zakat calculation — designed around Islamic values from the ground up, not adapted from a generic finance app."
          )}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 16,
          }}>
            <FeatureCard
              icon={<IconZakat />}
              iconBg="rgba(212,175,55,0.1)"
              title="Zakat calculator with live nisab"
              desc="Add your savings, gold, silver, and receivables. The app fetches live precious metal prices to calculate your exact nisab threshold and the 2.5% you owe — no spreadsheet, no guesswork. Fard made easy."
            />
            <FeatureCard
              icon={<IconMoon />}
              iconBg="rgba(167,139,250,0.1)"
              title="Riba awareness built in"
              desc="The app flags interest income so you never forget to purify it. Track what you owe in Sadaqah, donate it deliberately, and keep your wealth clean. No other budgeting app does this."
            />
            <FeatureCard
              icon={<IconShield />}
              iconBg="rgba(61,214,140,0.1)"
              title="Completely private by design"
              desc="No account. No server. No analytics. Your transactions live on your device — not a data centre overseas. Your finances are between you and Allah, not a Silicon Valley startup."
            />
            <FeatureCard
              icon={<IconTrend />}
              iconBg="rgba(245,166,35,0.1)"
              title="Halal-first categories & budgeting"
              desc="Categories built for Muslim life: Sadaqah, Zakat, Halal Food, Halal Finance. Budget presets include Islamic Thirds (Needs / Wants / Sadaqah), Balanced, and Conservative — no alcohol, gambling, or haram."
            />
            <FeatureCard
              icon={<IconTarget />}
              iconBg="rgba(61,214,140,0.1)"
              title="Islamic savings goals"
              desc="Save for what matters: Hajj Fund, Mahr, Emergency Fund, Sadaqah Jariya, or any custom goal. See your progress visually and watch your intentions become milestones."
            />
            <FeatureCard
              icon={<IconRepeat />}
              iconBg="rgba(167,139,250,0.1)"
              title="Debt tracker with riba awareness"
              desc="See every debt you carry and which ones bear riba. The app shows payoff timelines and helps you prioritise clearing haram obligations first — so you can live debt-free and riba-free."
            />
            <FeatureCard
              icon={<IconWifi />}
              iconBg="rgba(96,165,250,0.1)"
              title="Works fully offline — anywhere"
              desc="On a plane, in a mosque, in a remote area — the app works everywhere. No loading, no errors, no data required. Log transactions the moment they happen, with no friction."
            />
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          PRIVACY SPOTLIGHT
      ══════════════════════════════════════════════════════════ */}
      <section style={{ padding: "0 20px 80px" }}>
        <div style={{
          maxWidth: 1000,
          margin: "0 auto",
          background: "linear-gradient(135deg, rgba(61,214,140,0.05) 0%, rgba(14,14,19,0) 60%)",
          border: `1px solid rgba(61,214,140,0.12)`,
          borderRadius: 24,
          padding: "clamp(32px, 5vw, 56px)",
          display: "flex",
          flexWrap: "wrap",
          gap: 40,
          alignItems: "center",
        }}>
          {/* Left */}
          <div style={{ flex: "1 1 300px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 14,
                background: "rgba(61,214,140,0.1)",
                border: "1px solid rgba(61,214,140,0.2)",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <IconShield />
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.green, letterSpacing: "0.08em", textTransform: "uppercase" }}>Privacy First</div>
            </div>
            <h2 style={{ fontSize: "clamp(22px, 4vw, 30px)", fontWeight: 900, color: C.text, letterSpacing: "-0.025em", lineHeight: 1.25, margin: "0 0 14px" }}>
              Your finances are between you and Allah — not us.
            </h2>
            <p style={{ fontSize: 14, color: C.text2, lineHeight: 1.75, margin: 0 }}>
              Most finance apps monetise your data. We built Barakah Budget the opposite way — everything stays on your device. We physically cannot see your transactions because they are never sent to us. That's not a policy. That's how the software is built.
            </p>
          </div>
          {/* Right — checklist */}
          <div style={{ flex: "1 1 260px", display: "flex", flexDirection: "column", gap: 14 }}>
            {[
              "No account or sign-up — ever",
              "No server database storing your data",
              "No transaction data sent over the network",
              "Works fully offline — no internet needed",
              "Export your data anytime (JSON or CSV)",
              "Zero loading states — opens instantly",
            ].map((item, i) => (
              <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                <div style={{ marginTop: 2, flexShrink: 0 }}><IconCheck /></div>
                <span style={{ fontSize: 13, color: C.text, lineHeight: 1.5 }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          ISLAMIC FINANCE EDUCATION SECTION
      ══════════════════════════════════════════════════════════ */}
      <section style={{ padding: "0 20px 80px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          {sectionEyebrow("Islamic Finance, Explained Simply", C.amber)}
          {sectionHeading(
            "Know what you're tracking — and why it matters",
            "Barakah Budget builds these concepts into every screen. Here's what they mean."
          )}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: 16,
          }}>
            <EduCard
              icon={<IconPercent />}
              iconBg="rgba(251,191,36,0.1)"
              term="Zakat"
              definition="2.5% of qualifying wealth — savings, gold, silver, receivables — that has been held above the nisab threshold for one full lunar year. Zakat is one of the Five Pillars. Barakah Budget calculates your exact obligation automatically with live metal prices."
            />
            <EduCard
              icon={<IconScale />}
              iconBg="rgba(167,139,250,0.1)"
              term="Riba"
              definition="Interest — any guaranteed return on a loan regardless of business outcome. Riba is prohibited in Islam. The app flags interest income in your transactions so you can purify your wealth by donating the equivalent amount as Sadaqah."
            />
            <EduCard
              icon={<IconBook />}
              iconBg="rgba(245,166,35,0.1)"
              term="Nisab"
              definition="The minimum wealth threshold that makes Zakat obligatory. Calculated as the value of 85g of gold or 595g of silver — whichever you follow. Barakah Budget fetches live precious metal prices to keep this accurate in your local currency."
            />
            <EduCard
              icon={<IconHalal />}
              iconBg="rgba(61,214,140,0.1)"
              term="Halal Budgeting"
              definition="Ensuring your income comes from permissible sources, your spending avoids haram categories, and a portion is set aside for Zakat and Sadaqah. Barakah Budget structures your entire financial view around these principles — not as an afterthought, but as the foundation."
            />
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          PRICING
      ══════════════════════════════════════════════════════════ */}
      <section id="pricing" style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          {sectionEyebrow("Pricing", C.amber)}
          {sectionHeading(
            "Simple pricing. No tricks.",
            "Core halal budgeting is free — forever. Pro unlocks the full toolkit for serious financial management."
          )}
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "stretch" }}>
            <PricingCard
              tier="Free"
              price="CA$0"
              period=""
              subNote="Forever free"
              features={[
                "Unlimited transaction tracking",
                "Calendar view",
                "Monthly spending summary",
                "Budget presets (Islamic Thirds, Balanced, Conservative)",
                "Zakat calculator with live nisab",
                "Goals tracking (up to 3 goals)",
                "Debt tracker (up to 2 debts)",
                "Recurring bills tracker",
                "Export your data (JSON)",
                "Works offline — your data stays on your device",
              ]}
              highlight={false}
              cta="Download Free"
              href="https://apps.apple.com/app/id6772805412"
            />
            <PricingCard
              tier="Pro"
              price="CA$4.99"
              period="/month"
              subNote="or CA$39.99/year — save 33%"
              features={[
                "Everything in Free",
                "Unlimited goals & debts",
                "Spending analysis (category trends, month-over-month delta)",
                "Manual budget control — set every category yourself",
                "Net worth adjustments",
                "CSV export",
                "Priority support",
                "Early access to new features",
              ]}
              highlight={true}
              cta="Start with Web App"
              href="/app"
            />
          </div>
          <p style={{ textAlign: "center", fontSize: 12, color: C.text3, marginTop: 20 }}>
            Payments handled by Stripe · Cancel anytime · No hidden fees
          </p>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          FAQ SECTION
      ══════════════════════════════════════════════════════════ */}
      <section id="faq" style={{ padding: "0 20px 80px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          {sectionEyebrow("FAQ", C.purple)}
          {sectionHeading(
            "Questions people actually ask",
            null
          )}
          <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 20, padding: "8px 28px 0" }}>
            <FaqItem
              q="Is Barakah Budget free?"
              a="Yes. The core app is free forever — unlimited transaction tracking, Zakat calculator, calendar view, monthly spending summary, budget presets, goals (up to 3), debt tracker (up to 2 debts), recurring bills, and full offline access. Pro (CA$4.99/month or CA$39.99/year) unlocks unlimited goals and debts, spending analysis, manual budget control, CSV export, and priority support."
            />
            <FaqItem
              q="Is Barakah Budget available on iPhone?"
              a="Yes. Barakah Budget is available on the App Store for iPhone. Download it free at apps.apple.com. A full web app is also available at barakahbudget.com/app and works on any device with a browser — no install needed."
            />
            <FaqItem
              q="How does the Zakat calculator work?"
              a="You enter your savings, gold holdings, silver, and receivables. Barakah Budget fetches live gold and silver prices to calculate the current nisab threshold (approximately CA$1,491 using the silver standard). If your qualifying wealth exceeds nisab and has been held for one lunar year, the app calculates your exact 2.5% Zakat obligation — no spreadsheet needed."
            />
            <FaqItem
              q="Is my financial data safe?"
              a="Completely. All your data is stored on your device only — there is no server, no account, no cloud sync. Your transactions are never sent over the internet. Even the developers cannot see your data. You can export it anytime as a JSON or CSV backup. Your data belongs to you, full stop."
            />
            <FaqItem
              q="What makes Barakah Budget halal?"
              a="Barakah Budget is built around Islamic finance principles from the ground up. It flags riba (interest) income so you can purify it through Sadaqah, uses halal-aware spending categories, separates halal and riba-bearing debts, includes an automatic Zakat calculator with live nisab, and offers Islamic goal presets like Hajj Fund, Mahr, and Sadaqah Jariya. There are no alcohol, gambling, or haram categories anywhere in the app."
            />
            <FaqItem
              q="Does Barakah Budget work without internet?"
              a="Yes, completely offline. All data is stored on your device. You can log transactions, view your budget, check goals, and use the Zakat calculator with no internet connection. The only feature that uses the internet is fetching live gold/silver prices for nisab — and even that falls back gracefully to the last fetched value."
            />
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          FINAL CTA
      ══════════════════════════════════════════════════════════ */}
      <section style={{ padding: "0 20px 80px" }}>
        <div style={{
          maxWidth: 700,
          margin: "0 auto",
          textAlign: "center",
          background: C.surface,
          border: `1px solid ${C.border}`,
          borderRadius: 24,
          padding: "clamp(40px, 6vw, 64px) clamp(24px, 5vw, 56px)",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* Decorative glow */}
          <div aria-hidden="true" style={{
            position: "absolute",
            top: -60,
            left: "50%",
            transform: "translateX(-50%)",
            width: 300,
            height: 200,
            background: "radial-gradient(ellipse, rgba(167,139,250,0.12) 0%, transparent 70%)",
            pointerEvents: "none",
          }} />

          <div style={{ fontSize: 32, marginBottom: 16 }}>🌙</div>
          <h2 style={{
            fontSize: "clamp(22px, 4vw, 32px)",
            fontWeight: 900,
            color: C.text,
            letterSpacing: "-0.025em",
            lineHeight: 1.25,
            margin: "0 0 14px",
          }}>
            Your finances are an amanah.{" "}
            <span style={{
              background: `linear-gradient(135deg, ${C.green} 0%, ${C.purple} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}>Start treating them that way.</span>
          </h2>
          <p style={{ fontSize: 15, color: C.text2, lineHeight: 1.7, marginBottom: 12, maxWidth: 420, marginLeft: "auto", marginRight: "auto" }}>
            Download the iOS app or open the web app right now — no account, no install friction, no data leaving your device.
          </p>
          <p style={{ fontSize: 13, color: C.text3, marginBottom: 28 }}>
            🌍 Muslims in 15+ countries already tracking halal
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
            <a href="https://apps.apple.com/app/id6772805412" target="_blank" rel="noopener noreferrer" className="land-cta-primary" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "linear-gradient(135deg, #3dd68c, #22c55e)",
              color: "#0e0e13",
              fontWeight: 800,
              fontSize: 15,
              padding: "14px 28px",
              borderRadius: 14,
              textDecoration: "none",
              boxShadow: "0 4px 24px rgba(61,214,140,0.3)",
              transition: "opacity 0.15s, transform 0.15s",
            }}>
              <IconApple />
              Download on App Store
            </a>
            <a href="/app" className="land-cta-secondary" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "rgba(255,255,255,0.05)",
              color: C.text2,
              fontWeight: 600,
              fontSize: 15,
              padding: "14px 28px",
              borderRadius: 14,
              textDecoration: "none",
              border: `1px solid ${C.border}`,
              transition: "background 0.15s",
            }}>
              Open Web App <IconArrow />
            </a>
          </div>
          <p style={{ fontSize: 11, color: C.text3, marginTop: 20 }}>
            Free to download · No account required · Available on iPhone and Web
          </p>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          FOOTER
      ══════════════════════════════════════════════════════════ */}
      <footer style={{
        borderTop: `1px solid ${C.border}`,
        padding: "32px 20px 64px",
      }}>
        <div style={{
          maxWidth: 1000,
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          alignItems: "center",
          justifyContent: "space-between",
        }}>
          {/* Brand */}
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 16 }}>🌙</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: C.text2 }}>
              barakah<span style={{ color: C.green, fontWeight: 400 }}>budget</span>
            </span>
            <span style={{ fontSize: 12, color: C.text3, marginLeft: 4 }}>© 2026 Mufeed Muneer</span>
          </div>
          {/* Links */}
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center" }}>
            <a href="https://apps.apple.com/app/id6772805412" target="_blank" rel="noopener noreferrer" className="land-footer-link" style={{ fontSize: 12, color: C.green, textDecoration: "none", fontWeight: 600, transition: "color 0.15s" }}>
              Available on App Store
            </a>
            {[
              { label: "Privacy Policy", href: "/privacy" },
              { label: "Terms of Use",   href: "/terms" },
              { label: "Contact",        href: "mailto:hello@barakahbudget.com" },
            ].map(({ label, href }) => (
              <a key={label} href={href} className="land-footer-link" style={{
                fontSize: 12,
                color: C.text3,
                textDecoration: "none",
                transition: "color 0.15s",
              }}>{label}</a>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
